import {Injectable} from "@angular/core";
import {CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot} from "@angular/router";
import {UserService} from "./api_v1/user.service";

@Injectable()
export class IsAdminGuard implements CanActivate{

    constructor(private user: UserService){

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if(this.user.isAdmin())
        {
            return true;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/is-admin-guard.service.ts